module.exports = __webpack_public_path__ + "iac-long-logo.svg";